import { defineMessages } from 'react-intl';

export default defineMessages({
	requests: {
		id: 'csm-requests-header-link.requests',
		defaultMessage: 'Requests',
		description:
			'The text is shown as the label for a navigation link in the page header that takes the user to the list of their submitted customer service requests.',
	},
});
